import { Injectable } from '@angular/core';
import {
  TransactionQueryParams,
  TransactionQueryResult,
  TransactionData,
  TransactionActionCommand,
  TransactionsGroupedByAdvisor,
  TransactionUpdateResult
} from './transaction.model';
import { GetFileInputData, ResourceService } from 'common';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppSettings } from '../../app.settings';

@Injectable({
  providedIn: 'root'
})
export class TransactionService {
  private readonly serviceUrl: string;

  constructor(
    private http: HttpClient,
    private resourceService: ResourceService,
    private settings: AppSettings) {
      this.serviceUrl = this.settings.transaction.url;
  }

  get(id: number): Observable<TransactionData> {
    return this.http.get<TransactionData>(`${this.serviceUrl}/api/transactions/${id}`);
  }

  query(params: TransactionQueryParams): Observable<TransactionQueryResult> {
    return this.http.get<TransactionQueryResult>(`${this.serviceUrl}/api/transactions/list`, { params: <any>params });
  }

  groupedByAdvisor(params: TransactionQueryParams): Observable<TransactionsGroupedByAdvisor[]> {
    return this.http.get<any>(`${this.serviceUrl}/api/transactions/grouped-by-advisor`, { params: <any>params });
  }

  groupedByYear(params: TransactionQueryParams): Observable<any> {
    return this.http.get<any>(`${this.serviceUrl}/api/transactions/grouped-by-year`, { params: <any>params });
  }

  download(params: TransactionQueryParams): void {
    const inputData: GetFileInputData = {
      url: `${this.serviceUrl}/api/transactions/csv`,
      filename: "Transaction history.csv",
      params
    };
    this.resourceService.download(inputData).subscribe();
  }

  downloadHistoryUpcoming(loanId: number): void {
    const inputData: GetFileInputData = {
      url: `${this.serviceUrl}/api/transactions/loan/${loanId}/history-upcoming-csv`,
      filename: "full-amortization"
    };
    this.resourceService.download(inputData).subscribe();
  }

  update(command: TransactionActionCommand): Observable<TransactionUpdateResult> {
    return this.http.post<TransactionUpdateResult>(`${this.serviceUrl}/api/transactions`, command);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.serviceUrl}/api/transactions/${id}`);
  }

  addNotes(command: TransactionActionCommand): Observable<any> {
    return this.http.post(`${this.serviceUrl}/api/transactions/notes`, command);
  }

  getUnprocessedByLoan(loanId: number): Observable<TransactionData[]> {
    return this.http.get<TransactionData[]>(`${this.serviceUrl}/api/transactions/loan/${loanId}/unprocessed-transactions`);
  }
}
